export default function CoupleIntro() {
    return (<section className="hero is-info is-halfheight">
        <div className="hero-body">
            <div className="container has-text-centered">
                <div className="columns">
                    <div className="column">
                        <div className="content">
                            <p className="subtitle">Mempelai Pria</p>
                            <p className="title">
                                Bervianto Leo Pratama
                            </p>
                            <p>Putra pertama dari</p>
                            <p>Sak Tjie Min & Eva Rani Azzahra</p>
                        </div>
                    </div>
                    <div className="column">
                        <div className="content">
                            <p className="subtitle">Mempelai Wanita</p>
                            <p className="title">
                                Meti Habsari
                            </p>
                            <p>Putri bungsu dari</p>
                            <p>Sulihing Sungkowo ({"\u271D"}) & Sri Hartati ({"\u271D"})</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>);
}